import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import Container from "components/atoms/Container";
import PSPMarkdownContent from "components/molecules/PSPMarkdown/PSPMarkdownContent";
import { H2 } from "components/core/Typography";
import Image from "@sparefoot/react-commons/Image";

import "./SectionHeader.scss";


function SectionHeader(props) {
	const {
		title,
		description,
		contentAlign,
		additionalProps,
		titleProps,
		className,
		image,
		isPageContainer = true
	} = props;
	return (
		<div className={classnames("section-header", className, contentAlign)}>
			<Container isPageContainer={isPageContainer}>
				{image && (
					<Image
						src={image}
						alt="section-header-image"
						className={classnames("section-header-image")}
						lazy={false}
					/>
				)}
				{title && (
					<H2
						size="large"
						className={classnames("section-header-title")}
						{...titleProps}
					>
						{title}
					</H2>
				)}
				{description && (
					<PSPMarkdownContent
						content={description}
						additionalProps={{ ...additionalProps }}
					/>
				)}
			</Container>
		</div>
	);
}

SectionHeader.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	contentAlign: PropTypes.oneOf(["text-center", "text-left", "text-right"]),
	additionalProps: PropTypes.object,
	titleProps: PropTypes.object,
	className: PropTypes.string,
	image: PropTypes.string,
	isPageContainer: PropTypes.bool
};

SectionHeader.defaultProps = {
	contentAlign: "text-center"
};

export default SectionHeader;
